import { render, staticRenderFns } from "./Year_Published.vue?vue&type=template&id=a1571a2c&scoped=true"
import script from "./Year_Published.vue?vue&type=script&lang=js"
export * from "./Year_Published.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1571a2c",
  null
  
)

export default component.exports